import { debug, utils } from 'lib';
import { UiToast } from 'components';
import racePkLib from '../race-pk';

import forEach from 'lodash/forEach';

const log = debug.create('racePk');

const handle = (socket) => {
  socket.on('race.pk.first', (msg, { room }) => {
    room.update();
    racePkLib.loadInfo();
  });

  socket.on('race.pk.second', (msg) => {
    racePkLib.loadInfo();
  });

  socket.on('race.pk.third', (msg) => {
    racePkLib.loadInfo();
  });

  socket.on('race.pk.fourth', (msg, { room }) => {
    room.update();
    racePkLib.loadInfo();
  });
  socket.on('racepk.voice_switch', (msg, { room }) => {
    room.update();
  });
  // {
  // 			"duration":当前阶段持续时间
  // 			"value": 主播更新之后的pk值
  // 		}
  socket.on('race.pk.star_value_update', (msg, { lianmai: { racePk } }) => {
    racePk.info.mode_info.updatePkValue(msg.data.room_id, msg.data.pk_value[msg.data.room_id]);
    // racePkLib.loadInfo()
  });
  // {
  // 			"duration":当前阶段持续时间
  // 			"list": 数组对象
  // 					{
  // 						uid  用户id
  // 						pic 用户头像
  // 						value  用户贡献值
  // 					}
  // 		}
  socket.on('race.pk.user_rank_update', (msg, { lianmai: { racePk } }) => {
    racePk.info.mode_info.updateTopUser(msg.data.room_id, msg.data.top_user);
    // racePkLib.loadInfo()
  });

  // {
  //   "action": "race.pk.content_set",
  //   "data": {
  //     "100000004": "321"
  //   }
  // }

  socket.on('race.pk.match_tips', (msg, { room, lianmai: { racePk } }) => {
    log('match_tips', racePk.info.toJSON(), room.roomInfo.toJSON());

    UiToast.text('目前暂无匹配主播，请耐心等待或取消匹配');

    racePkLib.loadInfo();
  });
  socket.on('race.pk.match_cancel', (msg, { room, lianmai: { racePk } }) => {
    log('match_cancel', racePk.info.toJSON(), room.roomInfo.toJSON());

    UiToast.text(msg.data.msg || '匹配已取消');

    racePkLib.loadInfo();
  });
};

export default handle;
